module.exports = __webpack_public_path__ + "static/avatar-c5d7616206ec3c5ba94a8524ad4cda25.jpg";